export default __webpack_public_path__ + "static/stepTwoMeasureYourFinger-bb08bb96086d512dac664ee4a49b3147.png";